import React from "react";
import "./RequestDemoButton.css";

const RequestDemoButton = (props) => {
    return (
        <a className="btn-demo" href={props.url} target="_blank" >REQUEST A DEMO</a>
    );
};

export default RequestDemoButton;
